import { useCallback, useLayoutEffect, useState } from 'react'

interface UseBoxTruckTableScrollParams {
    scrollKey?: string
    readScrollTop?: (key: string) => number
    writeScrollTop?: (key: string, scrollTop: number) => void
}

/** Keeps one virtual table mounted while giving each Box Truck board its own vertical scroll position. */
export const useBoxTruckTableScroll = ({ scrollKey, readScrollTop, writeScrollTop }: UseBoxTruckTableScrollParams) => {
    const [scroller, setScroller] = useState<HTMLElement | null>(null)
    const captureScroller = useCallback((node: HTMLElement | Window | null) => setScroller(node instanceof HTMLElement ? node : null), [])

    useLayoutEffect(() => {
        if (!scroller || !scrollKey || !readScrollTop || !writeScrollTop) return

        scroller.scrollTop = readScrollTop(scrollKey)
        const save = () => writeScrollTop(scrollKey, scroller.scrollTop)
        scroller.addEventListener('scroll', save, { passive: true })

        return () => {
            save()
            scroller.removeEventListener('scroll', save)
        }
    }, [readScrollTop, scrollKey, scroller, writeScrollTop])

    return captureScroller
}
